module.exports = __webpack_public_path__ + "static/media/arrow.eb3e21f7.svg";